<template>
  <div v-if="tableData && tableData.length">
    <div
      class="flex align-center justify-between margin-top-lg"
      :class="UI.isMobile ? 'flex-direction' : ''"
    >
      <h1>报名中</h1>
    </div>
    <div class="full-width margin-bottom bg-grey" style="height: 1px;"></div>

    <el-table
      class="margin-top"
      :data="tableData"
      style="width: 100%"
      header-row-class-name="bg-default"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="game_start_time"
        label="赛事时间"
      ></el-table-column>
      <el-table-column prop="title" label="赛事名称"></el-table-column>
      <el-table-column prop="address" label="赛事地点"></el-table-column>
      <el-table-column prop="item" label="参赛项目"></el-table-column>
      <el-table-column prop="group" label="组别"></el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getPlayerById, getResultsById } from '@/servers/players.js';
import { checkIdentifierCode } from '@/servers/user.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import html2canvas from 'html2canvas';
import { idCardRegex } from '@/utils/reConsts.js';

export default {
  computed: {
    ...mapState(['UI', 'User']),
  },

  data() {
    return {
      tableData: [],
      filterForm: {
        page_size: 10,
        page: 1,
      },
      total: 0,
    };
  },

  watch: {
    $route: 'routeChange',
  },

  mounted() {
    this.routeChange();
  },

  methods: {
    routeChange: function() {
      let that = this;
      getPlayerById(this.$route.query.id, function(res) {
        that.playerInfo = res;
        that.flushData();
      });
    },

    flushData: function() {
      let that = this;
      this.page = 1;
      getResultsById(1, this.$route.query.id, this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'bg-gray';
      } else {
        return 'bg-white';
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/players/enrolling.vue